export default "__VITE_ASSET__6f84f751__"